export class Resume {
    _id: string;
    user: any;
    url_path: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;  
}
